import React from "react";
import { Container, Row, Col, Image } from "react-bootstrap";
import AboutHeroImg from "../../Assets/about-hero-img.png";
import Stagger from "../Stagger";
import MissionVision from "./MissionVision";
import HowWeWork from "./HowWeWork";
import AboutCard from "./AboutCard";
import TimeLine from "./TimeLine";
import StartConversationBlock from '../StartConversationBlock';

function About() {
    return (
        <div>
            <div className="about-wrapper">
                {/* Top Content */}
                <Container className="about-content">
                    <Row>
                        <Col md={6} className="pt-5">
                            <h2 className="heading-style-h2 pb-3">About <span className="text-gradient-1">Parabola IT</span></h2>
                            <h5 className='heading-style-h5 pb-5'>Driven by real-world demands, with a focus on software that works when it matters most. </h5>
                        </Col>
                    </Row>
                </Container>

                {/* Image Section */}

                <Container>
                    <div className="about-image-container">
                        <Image src={AboutHeroImg} className="about-image img-fluid" />
                    </div>
                </Container>
            </div>
            <AboutCard />
            <StartConversationBlock />
            <TimeLine />
            <MissionVision />
            <Stagger />
            <HowWeWork />
        </div>
    );
}

export default About;